// 线上明细
import React,{useState,useEffect} from 'react'
import {
  Row,
  Table,
  Form,
  Input,
  Space,
  Button,
  PageHeader
 } from 'antd';
import { withRouter } from "react-router-dom";
import { request } from '../../../../utils/fetch'
import store from '../../../../store/index'
 const FormItem = Form.Item;
 const itemStyle = {
     width:'300px',
     marginRight:'15px'
}
 const labelStyleObj = {
    labelCol:{ span: 9},
    wrapperCol:{ span: 15}
 }


function SettleQueryDetail(props) {
    let path = 'platform:Settlement'
    const [form] = Form.useForm();
    const {parmObj} = props
    const [tableData,setTableData] = useState([])
    const pageSize = 20     //每页条数
    const [total,setTotal] = useState(0)
    const [pageNum,setPageNum] = useState(1)
     
    const columns = [
        {
            title: '户名',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            align:'center',
            
        }, {
            title: '银行名称',
            dataIndex: 'bankName',
            key: 'bankName',
            width: 150,
            align:'center',
            
        }, {
            title: '银行账号',
            dataIndex: 'bankNumber',
            key: 'bankNumber',
            width: 150,
            align:'center',
            
        },{
            title: '金额',
            dataIndex: 'commissionAmount',
            key: 'commissionAmount',
            width: 150,
            align:'center',
            
        },
        {
            title: '操作',
            key: 'action',
            width: 260,
            align: 'center',
            fixed: 'right',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => getFile(record,1)}>下载</a>
                    {store.getState().userReducer.permissions.indexOf(`${path}:list`) > -1 && <a onClick={() => getFile(record,2)}>预览</a>}
                </Space>
            ),
        },
     
    ];
    const getFile = (record,type)=>{
        let data = { type: 3, sourceCode: record.settlementDetailNo }
        request.get('/platform/abcEnterpriseAccountConfig/getBankReceipt',data).then(res=>{
            console.log(res)
            if(type==1){
                request.renameDownload(res,res)
            }else{
                window.open(`/generic/web/viewer.html?file=${encodeURIComponent(res)}` )
            }
        }).catch((err)=>{
            console.log(err)
        })
    } 
    //组件渲染函数
    const myComponent = {
        renderSearchForm: () => {
            return (
                <Form form={form} >
                    <Row>
                        <FormItem label="关键字" name="keyword"  style={itemStyle} {...labelStyleObj}>
                            <Input placeholder="户名" />
                        </FormItem>
                        <FormItem style={{ float: 'right', whiteSpace: 'nowrap' }} >
                            <Button type="primary" onClick={methodsFn.handleSearch}>查询</Button>
                            <Button style={{ marginLeft: 10 }} onClick={methodsFn.handleFormReset}>重置</Button>
                            {store.getState().userReducer.permissions.indexOf(`${path}:export`)>-1&&<Button style={{ marginLeft: 10 }} onClick={methodsFn.handleExport}>导出</Button>}
                        </FormItem>
                    </Row>
                </Form>
            );
        },
    }
    //方法函数
    const methodsFn =  {
        getsearchObj(){
            return (
                {
                    paymentStatus: 'YZF',
                    keyword:form.getFieldsValue().keyword,
                    settlementNo:parmObj.settlementNo,
                    lineType:parmObj.lineType,
                }
            )
        },
        handleSearch() {
            setPageNum(1)
            methodsFn.getTableList(methodsFn.getsearchObj())
        },
        handleFormReset(){
            form.resetFields();
        },
        async getTableList(searchObj){
            let result = await request.get('/platform/settlement/getDetailList',{
                ...searchObj,
                pageSize:pageSize,
                pageNum:pageNum,
            })
               setTotal(result.totalCount)
               setTableData(result.list)
        },
        handleExport(){
            request.downExport('/platform/settlement/exportDetail',methodsFn.getsearchObj())
        }
    }
    useEffect(() => {
        methodsFn.getTableList(methodsFn.getsearchObj())
    },[pageNum])

    return (
        <div>
            <PageHeader
                className="site-page-header"
                onBack={props.callFn}
                title="查看"
                subTitle=""
            />
            {myComponent.renderSearchForm()}
           <Table 
            scroll={{ x: 'max-content',y: 500 }}
            columns={columns} 
            dataSource={tableData} 
            rowKey={(record) => record.idNumber}
            pagination={{
                position: ['bottomCenter'],
                total: total,
                current: pageNum,
                pageSize: pageSize,
                showSizeChanger:false,
                showTotal:(total) =>  `共 ${total} 条数据` ,
                onChange: (pageNum, pageSize) => setPageNum(pageNum)
            }}
           />

         
        </div>
    )
}

export default withRouter(SettleQueryDetail)
